import React from "react";
import { useLocation } from "react-router";
import Sidebar from "../components/sidebar/Sidebar";
import Admin from "../components/admin/Admin";

// AdminPage component renders the admin interface with a sidebar and admin content.
// It receives an openDrawer prop to control the sidebar drawer and extracts user data from the location state.
const AdminPage = ({ openDrawer }) => {
  // useLocation hook provides access to the location object, which contains the state passed through navigation.
  const location = useLocation();

  // Extracting user data from the location state. This data is used for rendering user-specific content and permissions.
  const UserData = {
    roles: location.state?.roles, // User roles (e.g., admin, editor)
    isAdmin: location.state?.isAdmin, // Boolean flag indicating if the user is an admin
    isAuthenticated: location.state?.isAuthenticated, // Boolean flag indicating if the user is authenticated
    refreshToken: location.state?.refreshToken, // Token used to refresh user session
    accessToken: location.state?.accessToken, // Token used for API requests
    userId: location.state?.userId, // Unique identifier for the user
    username: location.state?.username, // Username of the authenticated user
  };

  return (
    <>
      {/* Sidebar component with openDrawer and userData props. 
          The 'active' prop indicates the active menu item in the sidebar (7 in this case). */}
      <Sidebar openDrawer={openDrawer} userData={UserData} active={7} />
      
      {/* Admin component that renders the main admin content. It also receives the openDrawer prop. */}
      <Admin openDrawer={openDrawer} />
    </>
  );
};

export default AdminPage;
